export default{
  title: '特色案例研究',
  description: '了解maesinfo企业架构服务如何帮助公司实现数字化转型。',
  caseList: [
    {
      imgUrl: require('../../assets/images/cases/9.jpg'),
      title: '全球端游《幽灵战舰》',
      description: `
      1. 3D游戏沉浸感与真实感<br/>
      2. 游戏提供更高的自由度 让玩家自由体验游戏世界<br/>
      3. 3D 技术能呈现更细腻的细节，包括材质纹理、动态光影
      、天气变化和复杂的角色模型
      `
    },
    {
      imgUrl: require('../../assets/images/cases/10.jpg'),
      title: '雁江智慧工厂',
      description: `
      1. 关键工序全流程自动化，减少人工干预，提高生产效率<br/>
      2. 生产、设备、质量数据实时采集与展示，管理更透明<br/>
      3. 系统自动优化生产计划，缩短交付周期
      `
    },
    {
      imgUrl: require('../../assets/images/cases/1.jpg'),
      title: '智慧园区管理系统',
      description: `
      1. 智慧办公系统、人员管理系统<br/>
      2. 智慧物业系统-门禁系统、智慧停车系统、智慧用水/电系统、企业管理系统<br/>
      3. 智慧安防报警系统
      `
    },
    {
      imgUrl: require('../../assets/images/cases/2.jpg'),
      title: '企业生产信息化管理系统',
      description: `
      1. 工艺自动化流程管理、数据采集系统<br/>
      2. 库存管理、损耗分析系统、客户追踪系统<br/>
      3. 报表数据生成系统、财务系统
      `
    },
    {
      imgUrl: require('../../assets/images/cases/3.jpg'),
      title: '金融管理系统',
      description: `
      1. 交易和会计核算相互独立的核心系统、总账及财务管理系统<br/>
      2. 国际贸易统一支付平台<br/>
      3. 渠道整合平台、ODS数据平台
      `
    },
    {
      imgUrl: require('../../assets/images/cases/4.jpg'),
      title: '期货交易平台',
      description: `
      1. 企业级的数据仓库，企业统一数据字典以及统一的数据口径<br/>
      2. 安全态势感知平台、IT运维流程管理平台<br/>
      3. 统一监控告警信息展示平台
      `
    },
    {
      imgUrl: require('../../assets/images/cases/5.jpg'),
      title: '大数据应用平台（医疗行业）',
      description: `
      1.数字化智慧养老云平台<br/>
      2.医疗行业应用云平台<br/>
      3. 医疗图像分析平台
      `
    },
    {
      imgUrl: require('../../assets/images/cases/6.jpg'),
      title: '海外电商交易平台',
      description: `
      1. CRM系统<br/>
      2. 商机预存分析数据平台<br/>
      3. 线上购物网站和移动APP
      `
    },
    {
      imgUrl: require('../../assets/images/cases/7.jpg'),
      title: '全球跨境服务交易平台',
      description: `
      1. Melinked跨境服务平台<br/>
      2. b2b营销管理平台<br/>
      3. 国际贸易支付和结算平台
      `
    },
    {
      imgUrl: require('../../assets/images/cases/8.jpg'),
      title: '在线教育平台',
      description: `
      1. 直播教育平台，老师与学生的课件可以实时共享 <br/>
      2. 社交沟通平台，支持多种移动终端的平台<br/>
      3. 人工智能数字化教育云服务平台
      `
    }
  ]
}
